export default "__VITE_ASSET__Dgo8LaUa__"